// Central access tiers for BidBoard.
//
// Access is governed by the independent `permission` field (admin / manager /
// user / viewer), decoupled from the job-title `role`. `isAdmin` is a separate
// boolean and always qualifies as admin.
//
//   admin   -- everything, incl. admin tools (user mgmt, settings)
//   manager -- manage/edit/create any project; analytics, logs, archive, view-as
//   user    -- create projects; edit projects they're assigned to (Estimator/EC)
//   viewer  -- read only

export const isAdmin = (u) => !!u && !!u.isAdmin;

// Manager-or-above: the gate for analytics, activity log, user switching,
// archiving, must-win, bulk ops, and editing ANY project.
export const canManage = (u) => isAdmin(u) || u?.permission === 'admin' || u?.permission === 'manager';

// Who may create new projects.
export const canCreateProject = (u) => canManage(u) || u?.permission === 'user';

// A specific project is editable by managers/admins, or by whoever is assigned
// to it as its Estimator or Estimating Coordinator (the EC "owns" it).
export const canEditProject = (u, project) =>
  canManage(u) || (!!u && !!project && (u.userId === project.EstimatorId || u.userId === project.BidCoordinatorId));

export const canViewAnalytics     = canManage;
export const canViewActivityLog   = canManage;
export const canSwitchUsers       = canManage;
export const canManageUsers       = isAdmin;
export const canViewAdminSettings = isAdmin;
